export enum EventEnum {
  USER_LOGGED_IN = 'userLoggedIn',
  USER_LOGGED_OUT = 'userLoggedOut',
  LOGIN_SUCCESS = 'loginSuccess',
  BASKET_CHANGED = 'basketChanged',
  BASKET_PROMOTION_CALLED = 'basketPromotionCalled',
  BASKET_POPUP_VISIBLE = 'basketPopupVisible',
  SOCIAL_MEDIA_CONNECTION_ADDED = 'socialMediaConnectionAdded',
  VOUCHER_TEMPLATE_CHANGED = 'voucherTemplateChanged',
  VOUCHER_AMOUNT_CHANGED = 'voucherAmountChanged',
  VOUCHER_MESSAGE_CHANGED = 'voucherMessageChanged',
  WISHLIST_CHANGED = 'wishlistChanged',
  DYNAMIC_IMPORT_SUCCESS = 'dynamicImportSuccess',
  COOKIE_CONSENT_PREFERENCES = 'cookieConsentPreferences',
  COOKIE_CONSENT_PREFERENCES_UPDATED = 'cookieConsentPreferencesUpdated',
  COOKIE_CONSENT_PREFERENCES_SAVED = 'cookieConsentPreferencesSaved',
  NEW_VIDEO_IFRAME_ADDED = 'newVideoIframeAdded',
  VOUCHER_CHANGED = 'voucherChanged',
  USER_SECURITY_LEVEL_TOO_LOW = 'userSecurityLevelTooLowTrigger',
  LATITUDE_USER_LOGGED_IN = 'latitudeUserLoggedIn',
  MONETATE_SCRIPT_LOADED = 'monetateScriptLoaded',
  MONETATE_RECOMMENDATIONS = 'monetateRecommendations',
  SIZE_GUIDE_POPOVER_OPEN = 'sizeGuidePopoverOpen',
  APPLE_PAY_PAYMENT_FAILED = 'applePayPaymentFailed',
  MOBILE_NAVIGATION_CLICK = 'mobileNavigationClick',
  TARGET_MOBILE_NAV_DEPLOYED = 'Target Mobile Nav Cookie Deployed',
  TARGET_PDP_ANDES_DEPLOYED = 'Target PDP Andes Cookie Deployed',
}
